import React, { useEffect, useRef, useState } from 'react';

import { focusRef } from '../shared/EventHelpers';

const parseValue = (s) => {
    if (!s || !s.length) {
        return null;
    } else if (isNaN(s.replace(',', '.'))) {
        return NaN;
    } else {
        return parseFloat(s.replace(',', '.'));
    }
};

const parseCurrency = (s) => {
    if (!s || !s.length) {
        return null;
    } else if (isNaN(s.replace(',', '.'))) {
        return NaN;
    } else {
        return Math.round((parseFloat(s.replace(',', '.')) + Number.EPSILON) * 100) / 100;
    }
};

const EditNumber = ({ value, setValue, isCurrency, isInvalid, onKeyDown, autoFocus }) => {
    const inputRef = useRef();
    const [userInput, setUserInput] = useState('');

    useEffect(() => {
        autoFocus && focusRef(inputRef);
        setUserInput(value !== null && value !== undefined ? value.toString() : '');
        return () => setUserInput(value !== null && value !== undefined ? value.toString() : '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isCurrency) {
            setValue(parseCurrency(userInput));
        } else {
            setValue(parseValue(userInput));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInput]);

    return (
        <div className='crm-editable-field-wrapper'>
            <input
                ref={inputRef}
                className={'text-input' + (isInvalid ? ' invalid' : '')}
                value={userInput}
                onKeyDown={onKeyDown}
                onChange={(e) => setUserInput(e.target.value)}
            />
        </div>
    );
};

export default EditNumber;
